let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("asvK9"), load("aBa7j"), load("barSq"), load("gctEz"), load("QTjdE")]).then(() => parcelRequire('w1yis'));